var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("deferred-render-frame", {
    attrs: { "max-frame": _vm.framesForRenderAll },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({ currentFrame, maxFrameAchieved }) {
            return [
              _c(
                "div",
                [
                  _vm._l(_vm.cardNum, function (card, index) {
                    return [
                      _vm.isReadyToRender(currentFrame, index) ||
                      maxFrameAchieved
                        ? _c(
                            "div",
                            {
                              key: index,
                              class: { "mb-4": index !== _vm.cardNum - 1 },
                            },
                            [_vm._t("default")],
                            2
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }